export default "__VITE_ASSET__CDbxmWXk__"